// TODO:: Deprecate this component in other places and use FloatingDate component.
import moment from 'moment';
import React, { FC } from 'react';
import { HumanisedDate } from 'components/atoms/humanised-date';
import { useTranslation } from 'hooks/use-translation';
import styles from './date-separator.module.css';

type DateSeparatorProps = {
  currentCreatedAt: number;
  previousCreatedAt: number;
};

export const DateSeparator: FC<DateSeparatorProps> = ({
  currentCreatedAt,
  previousCreatedAt,
}) => {
  const showDateGroup = previousCreatedAt
    ? !moment(currentCreatedAt).isSame(previousCreatedAt, 'day')
    : true;

  const timestamp = currentCreatedAt;
  const today = useTranslation('today');
  const yesterday = useTranslation('yesterday');
  const dateString =
    (moment().isSame(timestamp, 'day') && today) ||
    (moment(timestamp).isSame(moment().subtract(1, 'day'), 'day') && yesterday);

  return showDateGroup ? (
    <span className={styles.wrapper}>
      <span className={styles.content}>
        {dateString || <HumanisedDate timestamp={moment(currentCreatedAt)} />}
      </span>
    </span>
  ) : (
    <></>
  );
};
